module.exports = __webpack_public_path__ + "fonts/Stelvio-Grotesk-Light.57f6ee5.woff";